import * as React from "react";
import { useState, useEffect } from "react";
import {
  Typography,
  Stack,
  Box,
  CircularProgress,
  Avatar,
  Alert,
  styled
} from "@mui/material";
import { useGetAllBureausQuery } from "../../app/services/bureauApi";
import { useGetCourQuery } from "../../app/services/courApi";
import BusinessIcon from "@mui/icons-material/Business";
import InfoIcon from "@mui/icons-material/Info";

const MarqueeContainer = styled(Box)({
  overflow: "hidden",
  whiteSpace: "nowrap",
  backgroundColor: "rgba(255, 255, 255, 0.8)",
  borderRadius: "4px",
  padding: "8px 0",
  margin: "16px 0",
  boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
  "&:hover .marquee-content": {
    animationPlayState: "paused"
  }
});

const MarqueeContent = styled(Box)(({ theme }) => ({
  display: "inline-block",
  paddingLeft: "100%",
  animation: "marquee 20s linear infinite",
  animationPlayState: "running",
  [`@keyframes marquee`]: {
    "0%": {
      transform: "translateX(0)"
    },
    "100%": {
      transform: "translateX(-100%)"
    }
  }
}));

const CurrencyItem = styled(Box)({
  display: "inline-flex",
  alignItems: "center",
  margin: "0 24px",
  "& > *": {
    margin: "0 8px"
  },
  "&:hover": {
    backgroundColor: "rgba(0, 0, 0, 0.05)",
    borderRadius: "4px"
  }
});

const ClientMessage = ({ message }) => (
<Box
      sx={{
        display: "flex",
        alignItems: "center",
        backgroundColor: "goldenrod", // couleur douce pour info
        color: "#000000",
        // borderRadius: 1,
        padding: 2,
        mb: 2,
        // boxShadow: 1,
        justifyContent: "start",
        textAlign: "start"
      }}
    >
      {/* <InfoIcon sx={{ fontSize: 24, mr: 1 }} /> */}
      <Typography variant="body1">{message}</Typography>
    </Box>
);

function BureauCours({ bureau }) {
  const { data, isLoading } = useGetCourQuery(bureau.id);

  if (isLoading) {
    return (
      <Box display="flex" justifyContent="center" p={2}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box sx={{ margin: "0 auto", mb: 4 }}>
      <Typography variant="h5" color="primary" gutterBottom>
        <BusinessIcon /> {bureau.nom} - {bureau.quartier}
      </Typography>
      {/* <Typography variant="body2">{bureau.adresse}</Typography> */}
      
      <MarqueeContainer>
        <MarqueeContent className="marquee-content">
          {data?.Bureau?.cours?.map((cour, index) => (
            <CurrencyItem key={index}>
              <Avatar
                alt={cour.devise.name}
                src={`${process.env.REACT_APP_BASE_FILE_URL}/Devise/image/${cour.devise.image}`}
                sx={{ width: 24, height: 24 }}
              />
              <Typography variant="subtitle1" fontWeight="bold">
                {cour.devise.name}
              </Typography>
              <Typography variant="body2">
                Achat: {cour.prixAchat}
              </Typography>
              <Typography variant="body2">
                Vente: {cour.prixVente}
              </Typography>
            </CurrencyItem>
          ))}
        </MarqueeContent>
      </MarqueeContainer>
    </Box>
  );
}

export default function CoursList() {
  const { data: bureaus, isLoading } = useGetAllBureausQuery();
  const clientMessage = "Nos taux de change sont actualisés quotidiennement. Survolez une devise pour mettre le défilement en pause et découvrir les taux d’achat et de vente.";

  if (isLoading) return <CircularProgress />;

  return (
    <Box sx={{ padding: 2 }}>
      <ClientMessage message={clientMessage} />
      
      <Stack spacing={4}>
        {bureaus?.map((bureau) => (
          <BureauCours key={bureau.id} bureau={bureau} />
        ))}
      </Stack>
    </Box>
  );
}